import { createAction } from "@reduxjs/toolkit";

// Objectives Actions
export const initObjectives = createAction("INIT_OBJECTIVES");
export const completeProtocol = createAction("COMPLETE_PROTOCOL");
export const completeStep = createAction("COMPLETE_STEP");
export const completeAndSkipStep = createAction("COMPLETE_AND_SKIP_STEP");
export const incrementStep = createAction("INCREMENT_STEP");
export const incrementCurrentStepSheetChanges = createAction(
  "INCREMENT_STEP_SHEET_CHANGES"
);
export const incrementUnsanitisedSheetChanges = createAction(
  "INCREMENT_UNSANITISED_SHEET_CHANGES"
);
